import type { Placement } from 'components/Tooltip/styles';

import { Tooltip } from '../../../../components/Tooltip';
import { isAdmin } from '../../../../domain/user';
import { useUserQuery } from '../../../../features/user/useUserQuery';
import { useIsSwUser } from '../../../../hooks/useIsSwUser';
import { appStore } from '../../../../services/appStore';
import { copyText } from '../../../../services/browser';
import { translate } from '../../../../services/i18n';

import { StyledButton, StyledLink } from './styles';

export type GdprRestrictedButtonVariant = 'single-reveal' | 'bulk-reveal' | 'bulk-export';

export const GdprRestrictedButton = ({
  placement = 'left',
  variant = 'single-reveal',
}: {
  placement?: Placement;
  variant?: GdprRestrictedButtonVariant;
}) => {
  const { data: userData } = useUserQuery();
  const isUserAdmin = isAdmin(userData);
  const isSwUser = useIsSwUser();
  const accountAdminEmails = userData?.accountAdminEmails ?? [];

  const accountUrl = 'https://account.similarweb.com/user-management';

  const onCopyEmail = () => {
    copyText(accountAdminEmails.join(', '))
      .then(() => {
        appStore.setToast({
          content: translate(
            accountAdminEmails.length === 1
              ? 'contact_card.country_restriction.copy.success'
              : 'contact_card.country_restriction.copy.success.multiple'
          ),
          icon: 'checked',
        });
      })
      .catch((err) => console.error("Couldn't copy to clipboard", err));
  };

  return (
    <Tooltip
      debounce={300}
      content={
        <>
          <div>
            {translate(
              isUserAdmin ? 'contact_card.country_restriction.admin' : 'contact_card.country_restriction.user'
            )}
          </div>{' '}
          {isUserAdmin || isSwUser ? (
            <StyledLink href={accountUrl} target="_blank">
              {translate('contact_card.country_restriction.link.admin')}
            </StyledLink>
          ) : (
            <>
              {accountAdminEmails.length > 0 ? (
                <>
                  {accountAdminEmails.join(', ')}
                  <StyledLink onClick={onCopyEmail}>
                    {translate(
                      accountAdminEmails.length === 1
                        ? 'contact_card.country_restriction.link.user'
                        : 'contact_card.country_restriction.link.user.multiple'
                    )}
                  </StyledLink>
                </>
              ) : null}
            </>
          )}
        </>
      }
      placement={placement}
      minWidth={222}
      className="restricted_reveal"
    >
      <StyledButton
        data-automation={variant === 'bulk-export' ? 'ContactExport' : 'ContactReveal'}
        disabled
        restrictedVariant={variant}
      >
        {translate(variant === 'bulk-export' ? 'contact_card.export_crm' : 'contact_card.reveal')}
      </StyledButton>
    </Tooltip>
  );
};
